module.exports = __webpack_public_path__ + "static/media/br-pe.dedf92e0.svg";